import { isRegExMatch } from "./RegExValidator";

// Note that `g` has been removed from end of this RegExp after `/`, because when it's used as JavaScript variable, it then causes WRONG comparison inside of regExp.test() logic
const emailRegExp =
  /^[a-zA-Z0-9_.!#%&'*+/=?`{|}~^-]+@((?!-)[a-zA-Z\d-]+(?<!-)\.)+((?!\d)[a-zA-Z0-9]{2,})$/;

export const isEmailAddressValid = (errorMessage: string) => {
  return isRegExMatch(emailRegExp, () => errorMessage);
};
